/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scl_New_Scenting_Date_LabelInputs */

const vi_scl_new_scenting_date_label = /** @type {(inputs: Scl_New_Scenting_Date_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngày lấy hương`)
};

/**

* @param {Scl_New_Scenting_Date_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const scl_new_scenting_date_label = /** @type {((inputs?: Scl_New_Scenting_Date_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scl_New_Scenting_Date_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_scl_new_scenting_date_label(inputs)
});